export const getMimeFromExtension = (filename: string) => {
  const ext = filename.split(".").pop()?.toLowerCase();
  if (!ext) return "";
  const map: Record<string, string> = {
    pdf: "application/pdf",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    svg: "image/svg+xml",
    jfif: "image/jpeg",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xls: "application/vnd.ms-excel",
    csv: "text/csv",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    doc: "application/msword",
    zip: "application/zip",
    rar: "application/x-rar-compressed",
  };
  return map[ext] || "";
};

export const isChatAttachmentImage = (filename: string, localPreviewUrl?: string) => {
  const mime = getMimeFromExtension(filename);
  return mime.startsWith("image/") || (!!localPreviewUrl && !mime);
};
